// Тексты ошибок для сброса пароля: ответы auth-service переводим в понятные клиенту сообщения.

export const NETWORK_ERROR_TEXT = "Не удалось связаться с сервером. Проверьте интернет и попробуйте ещё раз"

export const RESET_LINK_OUTDATED_TEXT =
  "Ссылка устарела, используйте ссылку из последнего письма или запросите новую"
export const RESET_LINK_BROKEN_TEXT = "Ссылка повреждена, запросите сброс заново"
export const USER_NOT_ACTIVE_TEXT = "Аккаунт не активен. Обратитесь к менеджеру"

export const EMAIL_NOT_FOUND_TEXT = "Почта не найдена. Проверьте адрес или обратитесь к менеджеру"
export const EMAIL_SEND_FAILED_TEXT = "Не удалось отправить письмо. Попробуйте позже"

const getResponse = (error: any) => (error && error.response) || null

// Ошибка сохранения нового пароля по ссылке из письма (POST reset_pass)
export const passwordCreationErrorText = (error: any): string => {
  const response = getResponse(error)
  if (!response) return NETWORK_ERROR_TEXT
  if (response.status === 403) return RESET_LINK_OUTDATED_TEXT
  if (response.data && response.data.error === "User is not active") return USER_NOT_ACTIVE_TEXT
  return RESET_LINK_BROKEN_TEXT
}

// Ошибка запроса письма со ссылкой (POST reset_pass_email)
export const restorePasswordErrorText = (error: any): string => {
  const response = getResponse(error)
  if (!response) return NETWORK_ERROR_TEXT
  if (response.status === 404) return EMAIL_NOT_FOUND_TEXT
  if (response.status === 400 && response.data && response.data.error) return response.data.error
  return EMAIL_SEND_FAILED_TEXT
}
